import { render, staticRenderFns } from "./RandoxBookingScreen.vue?vue&type=template&id=2dc68b38"
import script from "./RandoxBookingScreen.vue?vue&type=script&lang=js"
export * from "./RandoxBookingScreen.vue?vue&type=script&lang=js"
import style0 from "./RandoxBookingScreen.vue?vue&type=style&index=0&id=2dc68b38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports